import FlagContainer from './FlagContainer';

export default FlagContainer;
